import { NgModule } from '@angular/core';
import { SalesintelPrettyFieldPipe } from './salesintel-pretty-field.pipe';

@NgModule({
    declarations: [SalesintelPrettyFieldPipe],
    exports: [SalesintelPrettyFieldPipe],
})
export class SalesintelPrettyFieldPipeModule {}
